<template>
    <div class="c-loader"><div></div><div></div><div></div></div>
</template>